/**
 * @overview 版本管理
 * @author jzhu
 * @date 2020-12-24
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool

class Version extends WizContainer {

    componentName = 'Version'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(this),
            apiDataFormat: {}
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(Version)
